module.exports = __webpack_public_path__ + "static/media/router.3553944a.svg";